import { useClearDatasetData } from "api/api-hooks/datasets-hooks";
import { DatasetInfo } from "api/model/dataset/DatasetInfo";
import CalendarWrapper from "components/basic/calendar-wrapper/CalendarWrapper";
import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { easasConfirmDialog } from "components/fragments/easas-global-fragment/EasasGlobalConfirmDialog";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import React, { useState } from "react";
import { addToDate } from "utils/time-utils";

interface IClearDatasetDialogProps {
  selectedDatasetID: DatasetInfo[];
  setClearDataDialogVisibility: (value: boolean) => void;
}

const ClearDatasetDialog = ({
  setClearDataDialogVisibility,
  selectedDatasetID,
}: IClearDatasetDialogProps) => {
  const [clearAllCheck, setClearAllCheck] = useState(false);
  const [dateFrom, setDateFrom] = useState<Date>(addToDate(new Date(), -1, "HOURS"));
  const [dateTo, setDateTo] = useState<Date>(new Date());
  const identifiers = selectedDatasetID.map(dataset => dataset.identifier as String);

  const clearDataClickHandler = (e: any) => {
    e.preventDefault();
    easasConfirmDialog({
      icon: "pi pi-exclamation-triangle",
      header: "Confirm Action",
      confirmedCallback: clearData
    });
  };

  const { mutate } = useClearDatasetData();

  const clearData = () => {
    const timeStart = dateFrom.toISOString();
    const timeEnd = dateTo.toISOString();
    const clearAll = clearAllCheck;
    const query = { timeStart, timeEnd, clearAll, identifiers };

    mutate(query, {
      onSuccess: () => {
        easasAlert({
          summary: "DATASET CLEARED",
          detail: "Data has been cleared",
          severity: "success",
        });
      },
      onError: error => {
        easasAlert({ summary: "CLEARING FAILED", detail: `${error}`, severity: "error" });
      },
    });
    setClearDataDialogVisibility(false);
  };

  return (
    <div className="flex flex-column gap-5">
      <div className="flex justify-content-between align-items-center">
        <label htmlFor="clear-all"> Clear all data:</label>
        <Checkbox
          id="clear-all"
          className="mr-5"
          checked={clearAllCheck}
          onChange={() => setClearAllCheck(prevState => !prevState)}
        />
      </div>
      {!clearAllCheck && (
        <>
          <div className="flex justify-content-between align-items-center">
            <label htmlFor="date-from"> Clear data from:</label>
            <CalendarWrapper id="date-from" value={dateFrom} onChange={setDateFrom} />
          </div>
          <div className="flex justify-content-between align-items-center">
            <label htmlFor="date-to"> Clear data to:</label>
            <CalendarWrapper id="date-to" className="mr-0" value={dateTo} onChange={setDateTo} />
          </div>
        </>
      )}
      <div>{selectedDatasetID.length} datasets will be affected</div>
      <div className="flex justify-content-between align-items-center">
        <Button label="Cancel" onClick={() => setClearDataDialogVisibility(false)} />
        <Button
          label="Clear data"
          className="mr-5 p-button-danger"
          onClick={e => clearDataClickHandler(e)}
        />
      </div>
    </div>
  );
};

export default ClearDatasetDialog;
